import React, { useContext, useEffect, useState } from "react";
import { apiDelete, apiGet, apiPost, apiPut, instance } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { AiFillDelete, AiFillEdit, AiFillEye, AiOutlineHistory } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { isEmpty, startCase } from "lodash";
import helper from "../../utils/helpers";
import { Link, NavLink } from "react-router-dom";
import { TextField } from "@mui/material";
import OButton from "components/reusable/OButton";
import dayjs from "dayjs";

const ProjectTable = ({
  paginationObj,
  sort,
  setSort,
  list,
  fetchUnits,
  manager,
  filterData,
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();
  const [showAddUnitModal, setAddUnitModal] = useState(false);
  const [deleteUnitsModal, setDeleteUnitsModal] = useState(false);
  const [selctAllCheck, setSelectAllCheck] = useState(false);
  const [presentationUrl, setPresentationUrl] = useState(false);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [data, setData] = useState(list);

  useEffect(() => {
    setData(list);
  }, [list]);

  const handelDelete = async (item) => {
    try {
      const path = apiPath.unitPath + "/" + item?._id;
      const result = await apiDelete(path);
      if (result?.status === 200) {
        // getAllFAQ({ deletePage: 1 })
        const path = apiPath.unitPath;
        const result = await apiGet(path, {
          page: 1,
          pageCount: 1,
          pageRangeDisplayed: 10,
        });
        const response = result?.data?.results;
        setData(response?.docs);
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.isActive === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.ChangeStatusUnit}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        fetchUnits();
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };
  const addProposal = async () => {
    if (!selectedUnits?.length) {
      notification.error(t("PLEASE_ENTER_AT_LEAST_ONE_UNIT"));
      return;
    }
    if (user?.role !== "admin") {
      if (!user?.canCreateUnitProposal) {
        notification.error("You are not allowed to create unit proposal");
        return;
      }
      if (
        selectedUnits.find(
          (res) => !user?.allowedUnitProposalStatus?.includes(res?.status),
        )
      ) {
        notification.error(t("PLEASE_SLECT_ALLOWED_UNIT_PROPOSAL_STATUS"));
        return;
      }
    }
    setAddUnitModal(!showAddUnitModal);
  };
  const selctAllHandler = () => {
    setSelectAllCheck(!selctAllCheck);
    if (selectedUnits?.length === list?.length) {
      setSelectedUnits([]);
    } else setSelectedUnits(list?.map((res) => res));
  };

  const selectUnitHandler = (data) => {
    const isExists = selectedUnits?.find((res) => res?._id === data?._id);
    if (!isExists) {
      setSelectedUnits([...selectedUnits, data]);
    } else {
      setSelectedUnits(selectedUnits.filter((item) => item?._id !== data?._id));
    }
  };

  useEffect(() => {
    if (selectedUnits?.length !== list?.length) {
      setSelectAllCheck(false);
    }
  }, [list?.length, selectedUnits]);

  useEffect(() => {
    setPresentationUrl("");
  }, [showAddUnitModal]);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("✅ Copied successfully ");
    } catch (e) {
      console.log("❌ Failed to copy (insufficient permissions) ");
    }
  };

  const createProposalHandler = async () => {
    try {
      // if (!customerName?.trim()) {
      //   notification.error("Please enter customer name");
      //   return;
      // }
      let payload = [];
      selectedUnits.forEach((element) => {
        payload.push({ unitId: element?._id });
      });

      const path = apiPath.unitPresentation;
      const result = await apiPost(path, { units: payload, customerName });
      if (result?.status === 200) {
        notification.success(result.data.message);
        setPresentationUrl(result?.data?.results?.url);
        fetchUnits();
        // setAddModal(false);
        // setSelectedProperty([]);
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  async function exportUnitsHandler() {
    try {
      const {
        startDate,
        endDate,
        searchKey,
        status,
        floor,
        bedroom,
        propertyType,
        projectId,
      } = filterData || {};
      const result = await instance.get(apiPath.unitExportPath, {
        params: {
          sortKey: sort.sortKey,
          sortType: sort.sortType,
          ...(startDate && { startDate: dayjs(startDate).format("YYYY-MM-DD") }),
          ...(endDate && { endDate: dayjs(endDate).format("YYYY-MM-DD") }),
          ...(searchKey?.trim() && { keyword: searchKey.trim() }),
          ...(status && { status }),
          ...(floor && { floor }),
          ...(bedroom && { bedroom }),
          ...(propertyType && { propertyType }),
          ...(projectId && { projectId }),
        },
        responseType: "blob",
      });
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const dateStamp = new Date().toISOString().slice(0, 10);
      a.download = `units-export-${dateStamp}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  }

  async function deleteUnits() {
    if (!selectedUnits?.length) return;
    setDeleteUnitsModal(true);
  }

  async function unitsModalChangeHandler(isDelete) {
    if (isDelete)
      try {
        const requests = selectedUnits.map((unit) =>
          apiDelete(apiPath.unitPath + "/" + unit?._id),
        );
        await Promise.all(requests);
        notification.success("Units delete Successfully");
      } catch (error) {
        notification.error("Something went wrong, please try again later");
      }
    setDeleteUnitsModal(false);
    setSelectedUnits([]);
    await fetchUnits();
  }
  return (
    <>
      <div className="p-3">
        <div className="flex items-center gap-2">
          {(user?.role === "admin" || user?.canCreateUnitProposal) && (
            <button
              onClick={() => addProposal()}
              type="button"
              className="bg-[#8FC150] text-sm px-8 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2"
            >
              + Create Unit Proposal
            </button>
          )}

          {(manager?.view || manager?.import || user?.role === "admin") ? (
            <button
              onClick={exportUnitsHandler}
              type="button"
              className="bg-[#8FC150] text-sm px-8 mb-3 py-2 text-white rounded-lg sm:w-auto w-1/2"
            >
              Export
            </button>
          ) : null}
          {selectedUnits?.length && manager.delete ? (
            <button
              onClick={deleteUnits}
              type="button"
              className="bg-red-500 text-sm px-8 mb-3 py-2 text-white rounded-lg  border border-transparent  hover:bg-red-600 flex items-center justify-center gap-2 sm:w-auto w-1/2"
            >
              <AiFillDelete className="w-5 h-5 text-white" />
              <span>DeleteUnits</span>
            </button>
          ) : null}
        </div>
        <div className="overflow-x-auto relative  border">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  <input
                    type="checkbox"
                    id="check"
                    name="selectAll"
                    checked={selctAllCheck}
                    onChange={() => selctAllHandler()}
                  />
                </th>
                <th scope="col" className="py-3 px-6">
                  #
                </th>

                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex">
                    <span>{t("PROJECT")} </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex">
                    <span>{startCase(t("PROPERTY_TYPE"))} </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex">
                    <span>{t("O_FLOOR")} </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_TOTAL_AREA")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_PRICE")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_BEDROOM")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_STATUS")}
                </th>
                {(manager?.add || user?.role === "admin") && (
                  <th scope="col" className="py-3 px-6 text-center">
                    {t("O_ACTIVE_DE_ACTIVE")}
                  </th>
                )}
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.map((item, i) => (
                  <tr
                    key={i}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                  >
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      <input
                        type="checkbox"
                        id="check"
                        name="unit"
                        value={item?._id}
                        checked={selectedUnits.find(
                          (res) => res?._id === item?._id,
                        )}
                        onChange={() => selectUnitHandler(item)}
                      />
                    </th>
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className="py-2 px-2 border-r">
                      {item.projectTitle ? item.projectTitle : "N/A"}-
                      {item.unitNumber ? item.unitNumber : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r text-DarkBlue">
                      {item.unitType
                        ? item.unitType
                        : `N/A (${item?.prevUnitType})`}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.floor ? item?.floor : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {" "}
                      {item?.totalArea ? item?.totalArea : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {" "}
                      {item?.cost ? item?.cost : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.bedroom ? item?.bedroom : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.status ? item?.status : "N/A"}
                    </td>
                    {(manager?.add || user?.role === "admin") && (
                      <td className="py-2 px-2 border-r text-center">
                        <label
                          className="inline-flex relative items-center cursor-pointer"
                          title={`${
                            item?.isActive === "active" ? "Active" : "Inactive"
                          }`}
                        >
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={item?.isActive === "active"}
                            onChange={(e) =>
                              helper.alertFunction(
                                `Are you sure want to ${
                                  e.target.checked ? "active" : "inactive"
                                } ${item.unitNumber}?`,
                                item,
                                handelStatusChange,
                              )
                            }
                          />
                          <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                        </label>
                      </td>
                    )}
                    <td className="py-4 px-6 border-l">
                      <div className="">
                        <ul className="flex justify-center">
                          <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <NavLink to={`/units/detail`} state={{ item }}>
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                            </NavLink>
                          </li>
                          {(manager?.add || user?.role === "admin") && (
                            <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <Link
                                title={t("O_EDIT_PROJECT")}
                                to={`/units/edit-unit/${item?._id}`}
                                target="_blank"
                                state={{ item }}
                              >
                                <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                              </Link>
                            </li>
                          )}
                          {(manager?.delete || user?.role === "admin") && (
                            <li
                              onClick={(e) =>
                                helper.alertFunction(
                                  `Are you sure want to delete ${item.projectTitle}?`,
                                  item,
                                  handelDelete,
                                  true,
                                )
                              }
                              // onClick={() => handelDelete(item)}
                              className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                            >
                              <button title={t("O_DELETE")}>
                                <AiFillDelete className="w-5 h-5 text-red-600" />
                              </button>
                            </li>
                          )}
                          {user?.role === "admin" && (
                            <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <Link
                                title="History"
                                to={`/units/history/${item?._id}`}
                                state={{ item }}
                              >
                                <AiOutlineHistory className="cursor-pointer w-5 h-5 text-slate-600" />
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              {isEmpty(list) && (
                <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6" colSpan={12}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showAddUnitModal && (
        <div className="modal">
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6  w-full max-w-[1150px] mx-auto">
              <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl font-semibold">
                      Create Unit Presentation
                    </h3>
                    <button
                      className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                      onClick={() => {
                        setCustomerName("");
                        setSelectedUnits([]);
                        setPresentationUrl(false);
                        setAddUnitModal(!showAddUnitModal);
                      }}
                    >
                      <span
                        className=" text-[#B8BBBF]  text-4xl "
                        title="Close"
                      >
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="m-3">
                    <TextField
                      label="Customer Name"
                      type="text"
                      placeholder="Customer Name"
                      className="w-full"
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                      size="small"
                    />
                  </div>
                  <div className="overflow-x-auto relative border m-3">
                    <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                      <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="py-3 px-6">
                            <div className="flex">
                              <span>Unit Number</span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>Unit ID</span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6  ">
                            <div className="flex">
                              <span>Unit Type</span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_STARTING_PRICE")} </span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>Total Area</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedUnits &&
                          selectedUnits?.map((item) => {
                            return (
                              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                <th
                                  key={item?._id}
                                  scope="row"
                                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                                >
                                  {item?.unitNumber}
                                </th>
                                <td className="py-2 px-2 border-r">
                                  {item._id ? item._id : "N/A"}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {item?.unitType ? item?.unitType : "N/A"}
                                </td>

                                <td className="py-2 px-2 border-r">
                                  {item?.cost ? item?.cost : "N/A"}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {item?.totalArea ? item?.totalArea : "N/A"}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {presentationUrl && (
                    <div className="flex items-center justify-between p-5 rounded-t">
                      <p className="text-s font-semibold">
                        Project Presentation link:
                        <Link
                          to={presentationUrl}
                          target="_blank"
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            fontSize: 14,
                          }}
                        >
                          {`${presentationUrl}`}
                        </Link>
                      </p>
                      <div className="col-2 text-center ml-5">
                        <OButton
                          label={<>{t("COPY_URL")} </>}
                          type="button"
                          onClick={() => copyToClipboard(presentationUrl)}
                        />
                      </div>
                    </div>
                  )}

                  {!presentationUrl && (
                    <div className="col-2 text-center mb-5">
                      <OButton
                        label={<>{t("CREATE")} </>}
                        type="button"
                        onClick={() => createProposalHandler()}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </div>
      )}
      {deleteUnitsModal ? (
        <DeleteUnitsModal
          open={deleteUnitsModal}
          onChangeHandler={unitsModalChangeHandler}
          selectedUnits={selectedUnits}
        />
      ) : null}
    </>
  );
};

export default ProjectTable;

function DeleteUnitsModal({ open, selectedUnits, onChangeHandler }) {
  const { t } = useTranslation();
  if (open)
    return (
      <div className="modal">
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative my-6  w-full max-w-[1150px] mx-auto">
            <div className="sm:py-4 sm:px-2 py-8 px-7 ">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl font-semibold">
                    Please confirm{" "}
                    <span className="text-red-500">deleting</span> units
                  </h3>
                  <button
                    className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                    onClick={() => onChangeHandler(false)}
                  >
                    <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                      ×
                    </span>
                  </button>
                </div>

                <div className="overflow-x-auto relative border m-3">
                  <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                    <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                        <th scope="col" className="py-3 px-6">
                          <div className="flex">
                            <span>Unit Number</span>
                          </div>
                        </th>
                        <th scope="col" className="py-3 px-6 cursor-pointer">
                          <div className="flex">
                            <span>Unit ID</span>
                          </div>
                        </th>
                        <th scope="col" className="py-3 px-6  ">
                          <div className="flex">
                            <span>Unit Type</span>
                          </div>
                        </th>

                        <th scope="col" className="py-3 px-6 cursor-pointer">
                          <div className="flex">
                            <span>{t("O_STARTING_PRICE")} </span>
                          </div>
                        </th>

                        <th scope="col" className="py-3 px-6 cursor-pointer">
                          <div className="flex">
                            <span>Total Area</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedUnits &&
                        selectedUnits?.map((item) => {
                          return (
                            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                              <th
                                key={item?._id}
                                scope="row"
                                className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                              >
                                {item?.unitNumber}
                              </th>
                              <td className="py-2 px-2 border-r">
                                {item._id ? item._id : "N/A"}
                              </td>
                              <td className="py-2 px-2 border-r">
                                {item?.unitType ? item?.unitType : "N/A"}
                              </td>

                              <td className="py-2 px-2 border-r">
                                {item?.cost ? item?.cost : "N/A"}
                              </td>
                              <td className="py-2 px-2 border-r">
                                {item?.totalArea ? item?.totalArea : "N/A"}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="flex items-center gap-4 justify-end mx-8 my-4">
                  <button
                    onClick={() => onChangeHandler(false)}
                    className="bg-gray-500 text-sm px-8 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-gray-600 sm:w-auto w-1/2"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => onChangeHandler(true)}
                    className="bg-red-500 text-sm px-8 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-red-600 sm:w-auto w-1/2"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" />
      </div>
    );
}
